import { TableauLocalizedStrings } from "../../Strings";

export function showMobileAuthoringUnsupportedPage(
  doc: Document,
  strings: TableauLocalizedStrings
) {
  const renderer = new MobileAuthoringUnsupportedPageRenderer(doc, strings);
  doc.body.replaceChildren(renderer.getBodyContents());

  doc
    .querySelectorAll('style,link[rel="stylesheet"]')
    .forEach((element) => element.remove());
}

class MobileAuthoringUnsupportedPageRenderer {
  doc: Document;
  strings: TableauLocalizedStrings;

  constructor(doc: Document, strings: TableauLocalizedStrings) {
    this.doc = doc;
    this.strings = strings;
  }

  public getBodyContents() {
    const boldErrorPrefix = this.doc.createElement("b");
    boldErrorPrefix.innerHTML = this.strings.getString(
      "MobileAuthoringUnsupportedError"
    );

    const messageDiv = this.doc.createElement("div");
    messageDiv.style.margin = "0px 8px";
    messageDiv.innerHTML = this.strings.getString(
      "MobileAuthoringUnsupportedFeatureUnavailable"
    );

    const errorDiv = this.doc.createElement("div");
    errorDiv.className = "mobileAuthoringUnsupportedError";
    errorDiv.style.fontFamily = "Arial, Helvetica, sans-serif";
    errorDiv.style.backgroundColor = "#f8c7cb";
    errorDiv.style.boxShadow = "1px 1px rgba(0, 0, 0, 0.15)";
    errorDiv.style.display = "flex";
    errorDiv.style.padding = "12px 24px";
    errorDiv.style.margin = "24px";

    errorDiv.appendChild(boldErrorPrefix);
    errorDiv.appendChild(messageDiv);

    return errorDiv;
  }
}
